import { Box } from "@chakra-ui/react"

export default function DepositModalDivider() {
  return <Box w="100%" h="1px" bg="primary.black.20" my={8} />
}
